import React, {useEffect} from 'react';
import {useAppDispatch} from "../../hooks/redux";
import {appSlice} from "../../store/reducers/AppSlice";
import {TransactionType} from "../../model/TransactionType";
import CategoryTree from "../../components/categories/CategoryTree";

const IncomeCategoriesPage = () => {
    const dispatch = useAppDispatch();
    const {setTitle} = appSlice.actions;

    useEffect(() => {
        dispatch(setTitle('Income Categories'));
    });

    return <CategoryTree trType={TransactionType.Income}/>;
};

export default IncomeCategoriesPage;
